import { render } from "./App.vue?vue&type=template&id=5212cc90"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/scss/_custom-app.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=5212cc90&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__